import React, { useState } from 'react';
import { MessagingInspectionViewRequestDetails } from '../../../../../../../../types/rest/analyticsTypes';
import _ from 'lodash';
import { Button, ButtonGroup, Tab, Tabs } from 'react-bootstrap';
import BlazeTable from '../../../../../../../../components/blazeTable/BlazeTable';
import { BlazeTableOptions } from '../../../../../../../../components/blazeTable/BlazeTable.types';
import { isBase64 } from '../../../../../../../../utils/miscUtil';

interface Props {
  messageRequest: MessagingInspectionViewRequestDetails;
}

const MessagingInspectionDetail = ({ messageRequest }: Props) => {
  const [activeTab, setActiveTab] = useState('request');

  const getButtonGroup = () => {
    return (
      <div>
        <ButtonGroup className={'mb-2 mt-2'}>
          <Button
            key={'request'}
            onClick={() => {
              setActiveTab('request');
            }}
            className={'show-request-btn'}
            variant={activeTab === 'request' ? 'primary' : 'secondary'}
          >
            Request
          </Button>
          <Button
            key={'response'}
            onClick={() => {
              setActiveTab('response');
            }}
            className={'show-response-btn'}
            variant={activeTab === 'response' ? 'primary' : 'secondary'}
          >
            Response
          </Button>
        </ButtonGroup>
      </div>
    );
  };

  const getHeadersTableOptions = (table: 'headers' | 'properties'): BlazeTableOptions => ({
    showRowExpander: false,
    columnDef: [
      //Accessor differs by the table type
      { header: 'Name', accessor: table === 'headers' ? 'key' : 'name', width: 360 },
      { header: 'Value', accessor: 'value' },
    ],
    pageable: true,
    selectable: false,
    pageSize: 10,
    tableName: 'eventList',
    noResultsText: 'No items available',
    customHeaderClassName: 'flex-table-item-top',
    customTableClassName: 'flex-table-simple flex-table-condensed',
  });

  const getEncodedBody = (body: string) => {
    if (isBase64(body)) {
      return Buffer.from(body, 'base64').toString();
    } else {
      return body;
    }
  };

  const getRequestDetail = () => {
    return (
      <>
        <Tabs>
          <Tab eventKey="body" title={'Body'}>
            <label>Body Content</label>
            <p className={'requestBodyContent'}>
              {messageRequest.requestBody
                ? getEncodedBody(messageRequest.requestBody)
                : 'No Request Body Content available.'}
            </p>
          </Tab>
          <Tab eventKey="headers" title={'Headers (' + _.size(messageRequest.messageRequestHeaders) + ')'}>
            <BlazeTable
              options={getHeadersTableOptions('headers')}
              data={messageRequest.messageRequestHeaders ? messageRequest.messageRequestHeaders : []}
              showPageSizeDropdown={true}
            />
          </Tab>
          <Tab eventKey="properties" title={'Properties (' + _.size(messageRequest.messageRequestProperties) + ')'}>
            <BlazeTable
              options={getHeadersTableOptions('properties')}
              data={messageRequest.messageRequestProperties ? messageRequest.messageRequestProperties : []}
              showPageSizeDropdown={true}
            />
          </Tab>
        </Tabs>
      </>
    );
  };

  const getResponseDetail = () => {
    return (
      <>
        <Tabs>
          <Tab eventKey="body" title={'Body'}>
            <label>Body Content</label>
            <p className={'responseBodyContent'}>
              {messageRequest.responseBody
                ? getEncodedBody(messageRequest.responseBody)
                : 'No Response Body Content available.'}
            </p>
          </Tab>
          <Tab eventKey="headers" title={'Headers (' + _.size(messageRequest.messageResponseHeaders) + ')'}>
            <BlazeTable
              options={getHeadersTableOptions('headers')}
              data={messageRequest.messageResponseHeaders ? messageRequest.messageResponseHeaders : []}
              showPageSizeDropdown={true}
            />
          </Tab>
          <Tab eventKey="properties" title={'Properties (' + _.size(messageRequest.messageResponseProperties) + ')'}>
            <BlazeTable
              options={getHeadersTableOptions('properties')}
              data={messageRequest.messageResponseProperties ? messageRequest.messageResponseProperties : []}
              showPageSizeDropdown={true}
            />
          </Tab>
        </Tabs>
      </>
    );
  };

  return (
    <div>
      {_.isNil(messageRequest) ? (
        <div>Message Detail not available</div>
      ) : (
        <div>
          {getButtonGroup()}
          {activeTab === 'request' && <>{getRequestDetail()}</>}
          {activeTab === 'response' && <>{getResponseDetail()}</>}
        </div>
      )}
    </div>
  );
};

export default MessagingInspectionDetail;
